import React from "react";
//import Ads from "../../ad-config";
import { Bling as GPT } from "react-gpt";
  
GPT.enableSingleRequest();
export default class ROS_Top_Center_728_90 extends React.Component {
  render() {
    let Ads =this.props.AdData;
    let showAds = this.props.showAds;
    //console.log("top center called ")
    
    return (
  
         <>       
      {(() => {
        if (Object.keys(this.props.AdData).length> 0  && showAds ==  1) {
          return (
            <GPT
                  adUnitPath={Ads.adunitPath_rosTopCenter72890}
                  
                  name={Ads.name_rosTopCenter72890}
                   slotSize={[728, 90]}
      />
          )
        } 
      })()}
      </>
    );
  }
}
